import { Plan } from '.';

export interface UserPromo {
  total_tokens: number;
  finished_tokens: number;
  promo_code: string;
  used_tokens: number;
}

export enum CodeType {
  DISCOUNT = 'DISCOUNT',
  PROMO = 'PROMO',
  VOUCHER = 'VOUCHER',
}

export enum DurationUnit {
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export interface PaymentCodes {
  code: string;
  length: number;
  plans: Plan[];
  type: CodeType;
  unit: DurationUnit;
}
